import { Button } from './primitives/Button.js';
import './VideoModal.css';

export interface VideoModalProps {
  open: boolean;
  onClose: () => void;
  onGoDocs: () => void;
}

// The real product-review video, hosted on Google Drive. Overridable at
// build time via VITE_VIDEO_URL (see .env.example) — falls back to the
// current review video if unset. `toEmbeddableUrl` below normalizes a plain
// Drive share-link shape into its `/preview` embed form, so either a "share"
// link or an already-`/preview` link works as the override value.
const VIDEO_URL =
  import.meta.env.VITE_VIDEO_URL ||
  'https://drive.google.com/file/d/1Xu6f_CRLJbeRv3j9Iqjt3sQm0yIM1NyW/view?usp=sharing';

const DRIVE_FILE_ID_RE = /drive\.google\.com\/file\/d\/([^/]+)/;

function toEmbeddableUrl(url: string): string {
  const match = url.match(DRIVE_FILE_ID_RE);
  if (match) return `https://drive.google.com/file/d/${match[1]}/preview`;
  return url;
}

/** The product-review video, or a pending placeholder until the link is set. */
export function VideoModal({ open, onClose, onGoDocs }: VideoModalProps) {
  if (!open) return null;

  return (
    <div className="land-video-overlay" role="dialog" aria-modal="true" aria-label="Watch the review">
      <div className="land-video">
        <div className="land-video__header">
          <div>
            <div className="land-video__title">Watch the review</div>
            <div className="land-video__subtitle">Clean before it lands: your first Dedupr audit</div>
          </div>
          <button className="land-icon-btn" style={{ width: 32, height: 32 }} aria-label="Close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="land-video__content">
          {VIDEO_URL ? (
            <div className="land-video__player land-video__player--embed">
              <iframe
                className="land-video__iframe"
                src={toEmbeddableUrl(VIDEO_URL)}
                title="Dedupr product review"
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            </div>
          ) : (
            <div className="land-video__player">
              <span className="land-video__player-label">Video pending — link not yet set</span>
              <span className="land-video__play">▶</span>
            </div>
          )}

          <div className="land-video__actions">
            <Button variant="primary" size="lg" onClick={onClose}>
              Got it
            </Button>
            <Button variant="secondary" size="lg" onClick={onGoDocs}>
              Read the docs instead
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
